import {WebConferenceService} from "@share/web-conferences/data/WebConferenceService";
import {AgoraInterface} from "@share/web-conferences/interfaces/AgoraInterface";
import {AgoraScreenShareInterface} from "@share/web-conferences/interfaces/AgoraScreenShareInterface";
import {UserRoleType} from "@share/web-conferences/enums/UserRoleType";
import {AgoraCredentials} from "@api/models/web-conferences/AgoraCredentials";
import {sleep} from "@share/web-conferences/helpers/SleepHelper";
import {JoinHandlerInterface} from "@share/web-conferences/interfaces/JoinHandlerInterface";
import {showAccessErrorModal, showConnectionErrorModal} from "@share/web-conferences/helpers/ErrorModal";
import { WebConferenceError } from "@api/models/web-conferences/WebConferenceError";

const attemptsToReconnect = 3;

export class JoinHandler implements JoinHandlerInterface {
    cantJoin = false;

    constructor(
        public readonly webConferenceService: WebConferenceService,
        public readonly agora: AgoraInterface,
        public readonly shareClient: AgoraScreenShareInterface
    ) {
    }

    get webConferenceData() {
        return this.webConferenceService.webConferenceData;
    }

    async fetchWebConferenceData() {
        await this.webConferenceService.join();
    }

    async join() {
        let canJoin = false;
        let error: WebConferenceError | null  = null;

        for (let i = 1; i <= attemptsToReconnect; i++) {
            const result = await this.webConferenceService.join();

            if(result instanceof WebConferenceError) {
                error = result;
                break;
            }

            if (this.webConferenceService.isWebConferenceDataNotEmpty()) {
                canJoin = await this.joinMainClient();
                if (this.shareClient.joined) {
                    await this.joinScreenShareClient();
                }
                break;
            }
            else {
                await sleep(5000);
            }
        }
        this.cantJoin = !canJoin;

        if(error) {
            showAccessErrorModal(error.code);
        }
        else if(this.cantJoin && !this.webConferenceService.isWebConferenceDataNotEmpty()) {
            showConnectionErrorModal();
        }
    }

    async joinMainClient() {
        return await this.agora.join(
            this.webConferenceService.webConferenceData?.userRole as UserRoleType,
            this.webConferenceService.agoraCredentials as AgoraCredentials
        );
    }

    async joinScreenShareClient() {
        return await this.shareClient.join(
            this.webConferenceService.agoraCredentials as AgoraCredentials
        );
    }
}
